import script from "./SocialEventsListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialEventsListPage.vue?vue&type=script&setup=true&lang=js"

import "./SocialEventsListPage.vue?vue&type=style&index=0&id=28607c5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28607c5e"]])

export default __exports__